export const isNullOrEmpty = (value) => {
  return value === null || value === undefined || value.trim() === "";
};

export const appendScriptToHead = (url, defer, innerText) => {
  const node = document.createElement("script");
  node.src = url;
  node.type = "text/javascript";

  // Add innerText if provided
  if (innerText) {
    node.textContent = innerText;
  }

  if (defer) {
    node.defer = true;
  }

  // Prevent duplicate scripts
  if (!document.querySelectorAll(`script[src="${url}"]`).length) {
    document.getElementsByTagName("head")[0].appendChild(node);
  }
};

export const clearAuthStorage = () => {
  sessionStorage.removeItem("ert");
  sessionStorage.removeItem("prt");
  sessionStorage.removeItem("crt");
  sessionStorage.removeItem("tokenInfo");
  localStorage.removeItem("verifyMode");
};
